/**
 * Controls the #preloader element — progress bar and fade out.
 */

const preloaderEl = (): HTMLElement | null => document.getElementById('preloader');
const progressFillEl = (): HTMLElement | null => document.getElementById('progress-fill');

export function updateProgress(fraction: number): void {
  const fill = progressFillEl();
  if (fill) {
    fill.style.width = `${Math.min(fraction * 100, 100)}%`;
  }
}

export function hidePreloader(): void {
  const el = preloaderEl();
  if (el) {
    el.classList.add('hidden');
    // Remove from DOM after transition
    setTimeout(() => {
      el.style.display = 'none';
    }, 600);
  }
}
